import { TableColumn } from 'react-data-table-component';
import dayjs from 'dayjs';
import { InvestmentTableType } from '../../../Types/TablesType';

const currencyFormatter = new Intl.NumberFormat('es-CO', {
   style: 'currency',
   currency: 'COP',
   maximumFractionDigits: 0,
});

const percentageFormatter = new Intl.NumberFormat('en-US', {
   style: 'percent',
   maximumFractionDigits: 2,
});

export const tableColumnsInvestment: TableColumn<InvestmentTableType>[] = [
   {
      name: 'Fecha de operación',
      selector: (row) => dayjs(row['operationDate']).format('DD/MM/YYYY'),
      sortable: true,
      sortField: 'operation_date',
      center: true,
      minWidth: '150px',
      cell: (row) => (
         <div className="d-flex align-items-center">
            <i className="fa-regular fa-calendar me-2 text-muted"></i>
            <span>{dayjs(row['operationDate']).format('DD/MM/YYYY')}</span>
         </div>
      ),
   },
   {
      name: 'Tipo de operación',
      selector: (row) => row['type'] === 'INVESTMENT' ? 'Inversión' : 'Retiro',
      sortable: true,
      center: true,
      minWidth: '150px',
      cell: (row) => {
         const isInvestment = row.type === 'INVESTMENT';
         return (
            <span
               className={`badge badge-light-${isInvestment ? 'success' : 'danger'} rounded-pill px-3 py-2 fw-bold text-uppercase`}
               style={{ fontSize: '0.8rem', letterSpacing: '0.5px' }}
            >
               {isInvestment ? 'Inversión' : 'Retiro'}
            </span>
         );
      },
   },
   {
      name: 'Monto',
      selector: (row) => currencyFormatter.format(parseFloat(row.value)),
      sortable: true,
      center: true,
      minWidth: '160px',
      cell: (row) => {
         const isInvestment = row.type === 'INVESTMENT';
         return (
            <span
               className={`fw-bold ${isInvestment ? 'text-success' : 'text-danger'}`}
               style={{ fontSize: '0.95rem' }}
            >
               {isInvestment ? '+' : '-'} {currencyFormatter.format(parseFloat(row.value))}
            </span>
         );
      },
   },
   {
      name: 'Tasa de interés',
      selector: (row) => percentageFormatter.format(parseFloat(row.rate)),
      sortable: true,
      center: true,
      minWidth: '130px',
      cell: (row) => (
         <span className="badge badge-light-primary rounded-pill px-3 py-2 fw-medium">
            {percentageFormatter.format(parseFloat(row.rate))}
         </span>
      ),
   },
   {
      name: 'Fecha de registro',
      selector: (row) => dayjs(row['createdAt']).format('DD/MM/YYYY'),
      sortable: true,
      sortField: 'created_at',
      center: true,
      minWidth: '150px',
      cell: (row) => (
         <span className="text-muted" style={{ fontSize: '0.9rem' }}>
            {dayjs(row['createdAt']).format('DD/MM/YYYY')}
         </span>
      ),
   },
];

